import { Component, OnInit, LOCALE_ID, Inject } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { DatePipe } from '@angular/common';

interface TableRow {
  data1: string;
  data2: string;
  data3: string;
  data4: string;
  selectedDate: Date | null;
  isEditing: boolean;
}

@Component({
  selector: 'app-add-temp-dealer-code',
  templateUrl: './add-temp-dealer-code.component.html',
  styleUrls: ['./add-temp-dealer-code.component.scss']
})
export class AddTempDealerCodeComponent implements OnInit {

  username: string = '';
  inputTempDealerCode: string = '';
  showErrorMessage: boolean = false;
  showTempDealerErrorMsg: boolean = false;
  tempDealerCodeDetails: any;
  bsConfig: Partial<BsDatepickerConfig>;
  showTempDealerInputTable: boolean = false;
  showTempDetailsWithCalendar: boolean = false;
  isEditing: boolean;
  selecteduserType: string = '';
  tempCodeDetails: any;
  marketCountry: string = '';
  formattedCreatedDate: string | null;
  formattedDatePlusOne: string | null;
  fullDetails: any;
  formattedCreatedTimeStamp: string | null;
  errorMsg: string = '';
  dealerCode: string = '';
  loggedInUser: string = '';
  showInactiveSessionDetails: boolean = false;
  inactiveSessionDetails: any;

  constructor(private service: ApifirstService, private datePipe: DatePipe, @Inject(LOCALE_ID) private locale: string) {
    this.bsConfig = {
      //containerClass: 'theme-dark-blue', //Optional: Add a theme
      minDate: new Date(),   // Set min date to today
      maxDate: this.getMaxDate(), // Set max date to 7 days from now
      showWeekNumbers: false
    };
  }

  ngOnInit(): void {
    this.formattedCreatedDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd', this.locale);

    this.service.tokenObj.subscribe((data: any) => {
      this.marketCountry = data.country;
      this.dealerCode = data.dealerCode;
      this.loggedInUser = data.username;
    })

    const today = new Date();
    const tomorrow = new Date(today); // Create a copy of the date
    tomorrow.setDate(today.getDate() + 1); // Add one day

    this.formattedDatePlusOne = this.datePipe.transform(tomorrow, 'yyyy-MM-dd', this.locale);

  }

  getMaxDate(): Date {
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 6);
    return maxDate;
  }

  getInactiveSessionList() {
    this.showInactiveSessionDetails = true;
    this.showTempDealerInputTable = false;
    this.showTempDetailsWithCalendar = false;
    let req = {
      'userName': this.username,
      'dealerCode': this.dealerCode,
      'accountStatus': 'InActive'
    }
    this.service.requestTempDealerCode(req).subscribe((data) => {
      this.inactiveSessionDetails = data;
    })

  }

  submitUserName() {
    if (this.username.trim() != '') {
      this.showErrorMessage = false;
      let req = {
        'userName': this.username,
        'dealerCode': this.dealerCode,
        'accountStatus': 'Active'
      }
      this.service.requestTempDealerCode(req).subscribe((data) => {
        console.log('requested Data:', data);
        this.showTempDealerInputTable = true;
        this.showInactiveSessionDetails = false;
        if (data.length != 0) {
          this.tempCodeDetails = data[0];
          if (this.tempCodeDetails.tempdealercode != 'null') {
            this.createFullDealerCodeObj(this.tempCodeDetails);
          } else if (this.tempCodeDetails.tempdealercode == 'null') {
            this.inputTempDealerCode = '';
            this.showTempDetailsWithCalendar = false;
          }
        } else {
          this.showErrorMessage = true;
          this.showTempDealerInputTable = false;
          this.showTempDetailsWithCalendar = false;
          this.errorMsg = 'please enter the valid userName.'
        }
      }, (error: any) => {
        if (error.status == 404) {
          this.showErrorMessage = true;
          this.showTempDealerInputTable = false;
          this.showTempDetailsWithCalendar = false;
          this.errorMsg = 'please enter the valid userName.'
        }
      })
    } else {
      this.showTempDealerInputTable = false;
      this.showErrorMessage = true;
      this.errorMsg = 'Please enter a username'

    }
  }

  formatDate(dateValue: any) {
    const dateString = dateValue;
    const date = new Date(dateString);
    this.formattedCreatedTimeStamp = this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  createFullDealerCodeObj(fullDetails: any) {
    this.showTempDealerInputTable = false;
    this.showTempDetailsWithCalendar = true;
    this.showInactiveSessionDetails = false;
    this.tempDealerCodeDetails = [
      { sno: '1', username: fullDetails.username, dealerCode: fullDetails.dealerCode, tempCode: fullDetails.tempdealercode, expiryDate: fullDetails.expiringtimestamp, isEditing: false }
    ];
  }

  submitTempDealerCode() {
    if (this.inputTempDealerCode.trim() != '') {
      this.showTempDealerInputTable = false;
      this.showTempDealerErrorMsg = false;
      this.showTempDetailsWithCalendar = true;
      this.showInactiveSessionDetails = false;
      this.createReqObjToSubmitTempDealerCode('insert');
    } else {
      this.showTempDealerInputTable = true;
      this.showTempDetailsWithCalendar = false;
      this.showTempDealerErrorMsg = true;
      this.showInactiveSessionDetails = false;
    }
  }

  createReqObjToSubmitTempDealerCode(operation: string) {
    let req = {
      "whichOperation": operation,
      "userName": this.tempCodeDetails.username,
      "dealerCode": this.tempCodeDetails.dealerCode,
      "tempdealercode": this.inputTempDealerCode,
      "marketCountry": this.marketCountry,
      "createdtimestamp": this.formattedCreatedDate,
      "expiringtimestamp": this.formattedDatePlusOne,
      "assigneeUserName": this.loggedInUser
    }

    this.service.submitTempDealerDetails(req).subscribe((data) => {
      console.log('submit Temp Dealer Details:', data);
      this.fullDetails = data;
      this.tempDealerCodeDetails = [
        { sno: '1', username: this.fullDetails.username, dealerCode: this.fullDetails.dealerCode, tempCode: this.fullDetails.tempdealercode, expiryDate: this.fullDetails.expiringtimestamp, isEditing: false }
      ];
    })
  }

  editRow(row: TableRow) {
    row.isEditing = !row.isEditing;
    console.log('editRow:', row);
    var selectedDate: any = row.selectedDate;
    const dateString = selectedDate;
    const date = new Date(dateString);
    selectedDate = this.datePipe.transform(date, 'yyyy-MM-dd');
    this.createReqObjEditRemove(row, 'update', selectedDate)

  }

  removeRow(row: any) {
    console.log('remove entry:', row);
    this.createReqObjEditRemove(row, 'delete', '')
  }

  createReqObjEditRemove(dealerCodeDetailsObj: any, operationType: string, selectedDate: any) {
    let req = {
      "whichOperation": operationType,
      "userName": dealerCodeDetailsObj.username,
      "dealerCode": dealerCodeDetailsObj.dealerCode,
      "tempdealercode": dealerCodeDetailsObj.tempCode,
      "marketCountry": this.marketCountry,
      "createdtimestamp": this.formattedCreatedDate,
      "expiringtimestamp": selectedDate,
      "assigneeUserName": this.loggedInUser
    }
    this.service.submitTempDealerDetails(req).subscribe((data) => {
      console.log('Edit:', data);
      this.fullDetails = data;
      this.tempDealerCodeDetails = [
        { sno: '1', username: this.fullDetails.username, dealerCode: this.fullDetails.dealerCode, tempCode: this.fullDetails.tempdealercode, expiryDate: this.fullDetails.expiringtimestamp, isEditing: false }
      ];
    })
  }

  onDateChange(dateChange: any) {

  }

}
